import AddressSelect from './AddressSelect';

export default AddressSelect;
